export default "__VITE_ASSET__CZQUGDqd__"